import { DevPost } from '../types';

export function DevCard(post: DevPost): string {
  const tagsHtml = post.tags.map(tag => /*html*/`
    <span style="font-size: 0.72rem; padding: 0.2rem 0.5rem; border-radius: 4px; background: rgba(0, 210, 255, 0.12); color: #38bdf8; border: 1px solid rgba(0, 210, 255, 0.25);">
      ${tag}
    </span>
  `).join('');

  return /*html*/`
    <div class="glass-panel" style="display: flex; flex-direction: column; height: 100%; border-top: 3px solid #00d2ff; padding: 1.5rem; justify-content: space-between;">
      
      <div>
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 0.85rem;">
          <span class="badge badge-cyan">${post.category}</span>
          <span style="font-size: 0.8rem; color: #64748b;">${post.date}</span>
        </div>

        <h3 style="font-size: 1.15rem; font-weight: 700; color: #fff; margin-bottom: 0.75rem; line-height: 1.4;">
          <a href="${post.url}" target="_blank" rel="noopener noreferrer" style="color: #ffffff; text-decoration: none;">
            ${post.title}
          </a>
        </h3>

        <p style="font-size: 0.9rem; color: #94a3b8; line-height: 1.6; margin-bottom: 1.25rem;">
          ${post.summary}
        </p>

        <!-- Tags -->
        <div style="display: flex; flex-wrap: wrap; gap: 0.35rem; margin-bottom: 1.5rem;">
          ${tagsHtml}
        </div>
      </div>

      <!-- Action link -->
      <div style="border-top: 1px solid rgba(255,255,255,0.06); padding-top: 1rem;">
        <a href="${post.url}" target="_blank" rel="noopener noreferrer" class="btn-ghost" style="padding: 0.45rem 0.85rem; font-size: 0.82rem; width: 100%;">
          <sl-icon name="journal-code"></sl-icon>
          <span>Read on mydevblog →</span>
        </a>
      </div>

    </div>
  `;
}
